import type { FirebaseSdkCredentials } from "@jti/fe-common";

const requiredFirebaseConfigKeys = [
  "firebaseAppId",
  "firebaseApiKey",
  "firebaseAuthDomain",
  "firebaseMessagingSenderId",
  "firebaseProjectId",
  "firebaseStorageBucket",
] as const;

export const isFirebaseMessagingConfigValid = (
  firebaseConfig?: FirebaseSdkCredentials,
  messagingKey?: string
): boolean =>
  Boolean(messagingKey && firebaseConfig && requiredFirebaseConfigKeys.every((key) => Boolean(firebaseConfig[key])));
